import { StructuredError } from 'generated/resources/graphql'

import { FormErrors, useForm } from 'modules/core/hooks/useForm'
import { Result, UnhandledResult, handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

const MIN_CONTENT_LENGTH = 50

interface Props {
  onGenerate: (content: string) => Promise<UnhandledResult<Result<unknown>>>
  onSuccess?: () => void
}

export function useGenerateUsingAiForm({ onGenerate, onSuccess }: Props) {
  return useForm({
    defaultValues: {
      content: '',
    },
    validate(data) {
      const formErrors: FormErrors<{ content: string }> = {}

      if (!data.content) {
        formErrors.content = i18n.t('common.validations.empty')
      }

      if (data.content.length < MIN_CONTENT_LENGTH) {
        formErrors.content = i18n.t('common.validations.min_length', { count: MIN_CONTENT_LENGTH })
      }

      return formErrors
    },
    async onSubmit(data, { setErrors }) {
      const result = await onGenerate(data.content)

      const handled = handleResult(result, (responseErrors) => {
        setErrors(responseErrors)
      })

      if (handled.success) {
        onSuccess?.()
      } else {
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        const firstError = handled?.errors.at(0) as StructuredError | undefined

        if (firstError && firstError.field === 'errors') {
          app.setFlash({
            type: 'wrong',
            message: firstError.messages.join('. '),
          })
        }
      }

      return handled
    },
  })
}
